import React from "react";
import { Link } from "react-router-dom";
import FallbackImage from "../../components/FallbackImage/FallbackImage";

const ProductsPage = () => {
  const products = [
    {
      id: "mango-pulp",
      title: "Mango Pulp",
      description: "Premium mango pulp (Totapuri, Alphonso, Kesar) available in bulk aseptic packs, drums, and consumer-ready packs.",
      image: "media/New-Images/Mango.png",
      features: ["Bulk & retail packs", "Export quality"],
      color: "from-[#FF6B35] to-[#e85a2b]",
      textColor: "text-[#FF6B35]",
      borderColor: "border-[#FF6B35]/20",
    },
    {
      id: "avocado-pulp",
      title: "Avocado Pulp",
      description: "Rich and creamy avocado pulp, perfect for smoothies, desserts, and health-conscious food applications.",
      image: "media/New-Images/Avocado.png",
      features: ["High in healthy fats", "Creamy texture", "Nutrient dense"],
      color: "from-[#FF6B35] to-[#e85a2b]",
      textColor: "text-[#FF6B35]",
      borderColor: "border-[#FF6B35]/20",
    },
    {
      id: "guava-pulp", 
      title: "Guava Pulp",
      description: "Fresh guava pulp with authentic taste and natural sweetness, perfect for beverages and food processing applications.",
      image: "media/New-Images/Guava.png",
      features: ["High vitamin C", "Natural sweetness", "Multiple varieties"],
      color: "from-[#FF6B35] to-[#e85a2b]",
      textColor: "text-[#FF6B35]",
      borderColor: "border-[#FF6B35]/20",
    },
    {
      id: "pineapple-pulp",
      title: "Pineapple Pulp", 
      description: "Tropical pineapple pulp with tangy sweetness, ideal for desserts, smoothies, and beverages.",
      image: "media/New-Images/Pineapple.png",
      features: ["Tropical flavor", "Enzyme rich", "Premium quality"],
      color: "from-[#FF6B35] to-[#e85a2b]",
      textColor: "text-[#FF6B35]",
      borderColor: "border-[#FF6B35]/20",
    },
    {
      id: "passion-fruit-pulp",
      title: "Passion Fruit Pulp",
      description: "Exotic passion fruit pulp with intense tropical flavor, perfect for premium beverages and desserts.",
      image: "media/New-Images/Passion fruit.png",
      features: ["Intense tropical flavor", "Aromatic", "Premium exotic fruit"],
      color: "from-[#FF6B35] to-[#e85a2b]", 
      textColor: "text-[#FF6B35]",
      borderColor: "border-[#FF6B35]/20",
    },
    {
      id: "jackfruit-pulp",
      title: "Jackfruit Pulp",
      description: "Sweet and aromatic jackfruit pulp, ideal for traditional desserts and innovative food applications.",
      image: "media/New-Images/Jack fruit.png",
      features: ["Unique sweet flavor", "Traditional favorite", "Versatile applications"],
      color: "from-[#FF6B35] to-[#e85a2b]",
      textColor: "text-[#FF6B35]",
      borderColor: "border-[#FF6B35]/20",
    },
    {
      id: "coconut-pulp",
      title: "Tender Coconut Pulp",
      description: "Fresh coconut pulp with natural sweetness, perfect for beverages, desserts, and culinary applications.",
      image: "media/New-Images/Tender coconut.png",
      features: ["Natural coconut flavor", "Rich texture", "Tropical essence"],
      color: "from-[#FF6B35] to-[#e85a2b]",
      textColor: "text-[#FF6B35]",
      borderColor: "border-[#FF6B35]/20",
    },
    {
      id: "chikoo-pulp",
      title: "Chikoo (Sapota) Pulp",
      description: "Sweet and smooth chikoo pulp with natural caramel-like flavor, ideal for desserts and beverages.",
      image: "media/New-Images/Chikkoo.png",
      features: ["Natural sweetness", "Smooth texture", "Caramel notes"],
      color: "from-[#FF6B35] to-[#e85a2b]",
      textColor: "text-[#FF6B35]",
      borderColor: "border-[#FF6B35]/20",
    },
    {
      id: "coconut-date-pulp",
      title: "Tender Coconut Date Pulp",
      description: "Premium blend of coconut and date pulp, combining tropical and natural sweetness for unique applications.",
      image: "media/New-Images/Tender coconut with dates.png",
      features: ["Natural sweetness", "Unique blend", "Rich in nutrients"],
      color: "from-[#FF6B35] to-[#e85a2b]",
      textColor: "text-[#FF6B35]",
      borderColor: "border-[#FF6B35]/20",
    },
  ];

  return (
    <div className="min-h-screen bg-[#F3F4F6]">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-[#FF6B35] to-[#e85a2b] pt-28 md:pt-32 pb-24">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Our Product Range
          </h1>
          <p className="text-xl md:text-2xl text-white/90 max-w-4xl mx-auto leading-relaxed">
            Discover our comprehensive collection of premium fruit pulps and frozen products, 
            crafted with care from farm to fork
          </p>
          <div className="mt-8 flex justify-center">
            <div className="bg-white/20 backdrop-blur-sm rounded-full px-6 py-3">
              <span className="text-white font-semibold">100% Natural • No Preservatives • Export Quality</span>
            </div>
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-[#0B1E2B] mb-6">
              Premium Fruit Pulp Collection
            </h2>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto">
              From traditional favorites to innovative blends, explore our diverse range of 
              high-quality fruit pulps designed for B2B buyers, retail brands, and export markets.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {products.map((product) => (
              <div 
                key={product.id}
                className={`group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border-2 ${product.borderColor}`}
              >
                {/* Image Section */}
                <div className="relative aspect-square overflow-hidden bg-[#F3F4F6] flex items-center justify-center">
                  <FallbackImage
                    src={`/${encodeURI(product.image)}`}
                    alt={product.title}
                    className="w-full h-full object-contain transition-transform duration-300"
                    placeholderText={product.title}
                  />
                  
                  {/* Floating Badge */}
                  <div className="absolute top-4 right-4">
                    <span className={`bg-white ${product.textColor} px-3 py-1 rounded-full text-sm font-semibold shadow-lg`}>
                      Premium Quality
                    </span>
                  </div>
                </div>

                {/* Content Section */}
                <div className="p-8">
                  <h3 className="text-2xl font-bold text-[#0B1E2B] mb-4 group-hover:text-[#FF6B35] transition-colors duration-300">
                    {product.title}
                  </h3>
                  <p className="text-gray-600 mb-6 leading-relaxed line-clamp-3">
                    {product.description}
                  </p>

                  {/* Features */}
                  <div className="space-y-3 mb-6">
                    {product.features.map((feature, index) => (
                      <div key={index} className="flex items-center space-x-3">
                        <div className="w-2 h-2 rounded-full bg-[#FF6B35]"></div>
                        <span className="text-gray-700 font-medium">{feature}</span>
                      </div>
                    ))}
                  </div>
                  <div className="mb-6 text-left">
                    <p className="text-sm font-medium text-[#FF6B35] mb-2">Available in</p>
                    <div className="flex gap-2 justify-start">
                      <span className="inline-flex items-center justify-center px-4 py-2 rounded-lg bg-transparent text-[#FF6B35] text-sm font-medium border-2 border-[#FF6B35] pointer-events-none select-none">
                        Frozen
                      </span>
                      <span className="inline-flex items-center justify-center px-4 py-2 rounded-lg bg-transparent text-[#FF6B35] text-sm font-medium border-2 border-[#FF6B35] pointer-events-none select-none">
                        Aseptic
                      </span>
                    </div>
                  </div>
                  {/* CTA Button */}
                  <Link
                    to={`/products/${product.id}`}
                    className={`inline-flex items-center justify-center w-full bg-gradient-to-r ${product.color} text-white font-semibold py-4 px-6 rounded-xl hover:shadow-lg transition-all duration-300`}
                  >
                    <span>Explore {product.title}</span>
                    <svg className="w-5 h-5 ml-2 transition-transform duration-300 group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-[#0B1E2B] mb-4">
              Why Choose Zenvia Foods Fruit Pulp?
            </h2>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto">
              Trusted by institutional kitchens, restaurants, and global retail chains worldwide
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                icon: "🌱",
                title: "100% Natural",
                description: "No artificial preservatives, colors, or additives"
              },
              {
                icon: "🏭", 
                title: "Modern Facility",
                description: "State-of-the-art processing at our facility"
              },
              {
                icon: "❄️",
                title: "Cold Chain Excellence", 
                description: "Blast freezers and –20°C storage maintain freshness"
              },
              {
                icon: "🎯",
                title: "Export Quality",
                description: "HACCP, FSSAI compliant with full traceability"
              }
            ].map((item, index) => (
              <div key={index} className="bg-[#F3F4F6] rounded-xl p-6 text-center shadow-md hover:shadow-lg transition-shadow duration-300">
                <div className="text-4xl mb-4">{item.icon}</div>
                <h3 className="text-xl font-bold text-[#0B1E2B] mb-3">{item.title}</h3>
                <p className="text-gray-700">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-[#FF6B35] to-[#e85a2b]">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Ready to Partner With Us?
          </h2>
          <p className="text-xl text-white/90 mb-8 leading-relaxed">
            Join institutional kitchens, restaurants, and global retail chains who trust 
            Zenvia for their fruit pulp needs.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact-us"
              className="bg-white text-[#FF6B35] font-semibold py-4 px-8 rounded-xl hover:bg-[#F3F4F6] transition-colors duration-300 shadow-lg hover:shadow-xl"
            >
              Get In Touch
            </Link>
            <Link
              to="/brochure"
              className="border-2 border-white text-white font-semibold py-4 px-8 rounded-xl hover:bg-white hover:text-[#FF6B35] transition-colors duration-300"
            >
              Download Brochures
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductsPage;
